import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-273">
      <div className="flex items-center gap-3" data-id="element-274">
        <div className="w-12 h-12 rounded-full bg-[#FFD700]/20 border border-[#FFD700]/40 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-275">
          {initials}
        </div>
        <div data-id="element-276">
          <div className="text-[#FFD700] text-sm" data-id="element-277">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-278">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-279">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-280">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-281">
      <div className="max-w-5xl mx-auto" data-id="element-282">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-283">
          Lo que dicen los docentes de Música
          <br data-id="element-284" />
          <span className="text-[#FFD700]" data-id="element-285">que ya tienen su PROFEPACK:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-286">
          +3.000 docentes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-287">
          <TestimonialCard initials="MG" stars={5} quote="Compré el PROFEPACK un domingo a la noche. El lunes tenía todo el año de Música de primaria organizado. Nunca pensé que un material iba a ser tan completo. Los guiones de clase son exactamente lo que necesitaba: no tengo que pensar de cero para cada clase." name="Mariela G." location="Córdoba" level="Docente de Música Primaria" data-id="element-288" />
          <TestimonialCard initials="CR" stars={5} quote="Empecé con Primaria y a los 3 días compré el Pack Completo. Doy clases en los dos niveles y no podía trabajar con la mitad del sistema. El Manual de Manejo de Grupo me cambió las clases de secundaria: mis alumnos ahora saben cómo funciona la clase desde el primer minuto." name="Cecilia R." location="Mendoza" level="Docente de Música Primaria y Secundaria" data-id="element-289" />
          <TestimonialCard initials="RM" stars={5} quote="El Kit de Efemérides me salvó el año. Los actos siempre eran mi peor pesadilla. Con PROFEPACK resolví el 25 de Mayo en 30 minutos con guion, roles y ensayo incluido. Mis colegas me preguntaron cómo lo había preparado tan bien." name="Roberto M." location="Buenos Aires" level="Docente de Música" data-id="element-290" />
          <TestimonialCard initials="FL" stars={5} quote="Lo que más valoro es que está organizado POR GRADO. No tengo que adivinar qué le corresponde a cada año de primaria. Todo ya está pensado, ordenado y listo. Es como tener un colega experto que ya hizo todo el trabajo por mí." name="Fernando L." location="Tucumán" level="Docente de Música Primaria" data-id="element-291" />
          <TestimonialCard initials="LP" stars={5} quote="Como profe de secundaria lo que más me cambió fueron los tomos 3, 4 y 5. Mis alumnos de 3° y 4° año por fin enganchan con la clase porque el contenido los conecta con lo que escuchan hoy. Ya no tengo que pelearme con el celular." name="Laura P." location="Rosario" level="Docente de Música Secundaria" data-id="element-292" />
          <TestimonialCard initials="VT" stars={5} quote="No tengo instrumentos en la escuela y pensé que el material no me iba a servir. Pero el Bono de Materiales Cero Presupuesto resolvió todo. Mis clases funcionan con el cuerpo, la voz y objetos del aula. No necesité gastar nada más." name="Valeria T." location="Santa Fe" level="Docente de Música Primaria" data-id="element-293" />
        </div>
      </div>
    </section>;
}